import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import AppButton from '../atoms/AppButton';
import Reveal from '../atoms/Reveal';
import { IconArrowRight } from '../atoms/Icon';
import FeatureCard from '../molecules/FeatureCard';
import { BrowserFrame, MenuMockup } from '../molecules/Mockups';
import { cardapio, contato } from '../content/site';
import { trackEvent } from '../utils/analytics';

/** O lado do cliente. A maquete vem antes dos cartões porque o argumento desta
 *  seção é visual: o link com o nome do restaurante na barra de endereço diz em
 *  um segundo o que três parágrafos explicariam. */
function MenuSection() {
  return (
    <section className="section section--alt" id="cardapio">
      <Container className="shell">
        <Row className="align-items-start g-4 gy-5 mb-5">
          <Col lg={6}>
            <span className="section-kicker">{cardapio.kicker}</span>
            <h2 className="section-title">{cardapio.titulo}</h2>
            <p className="section-lead mb-4">{cardapio.texto}</p>

            <AppButton
              href={contato.demoUrl}
              variant="ghost"
              onClick={() => trackEvent('click_demo_cardapio')}
            >
              Ver cardápio de exemplo
              <IconArrowRight size={17} />
            </AppButton>
          </Col>

          <Col lg={6}>
            <Reveal heavy>
              <BrowserFrame
                url={
                  <>
                    {contato.menuUrl.replace('https://', '')}/<b>pizzaria-do-ze</b>
                  </>
                }
              >
                <MenuMockup />
              </BrowserFrame>
            </Reveal>
          </Col>
        </Row>

        <div className="card-grid">
          {cardapio.itens.map((item, i) => (
            <Reveal key={item.titulo} stagger={i}>
              <FeatureCard {...item} />
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default MenuSection;
